import _ from 'lodash';
import Vue from 'vue';
// @ts-ignore
import VueWorker from 'vue-worker';
import VueLogger from 'vuejs-logger';
import VueI18n from 'vue-i18n';
import BootstrapVue from 'bootstrap-vue';
// @ts-ignore
import VueSlideoutPanel from '@/components/utils/slideout-panel';
// @ts-ignore
import ToggleButton from 'vue-js-toggle-button';
import Multiselect from 'vue-multiselect';
import { sync } from 'vuex-router-sync';
import VueCookies from 'vue-cookies';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@/faicons.conf';
import { i18n } from './i18n-setup';
import App from './App.vue';
import router from './router';
import store from './store';
import './filters/common';
import longpress from '@/directives/longpress';
import ButtonSwitch from '@/components/controls/ButtonSwitch.vue';
import SliderSwitch from '@/components/controls/SliderSwitch.vue';
import SelectBox from '@/components/controls/SelectBox.vue';
import Timer from '@/components/controls/Timer.vue';
import TimeInput from '@/components/controls/TimeInput.vue';
import RGBPicker from '@/components/controls/RGBPicker.vue';
import Slider from '@/components/controls/Slider.vue';
import NumberInput from '@/components/controls/NumberInput.vue';
import SecMillisNumberInput from '@/components/controls/SecMillisNumberInput.vue';
import OTEPriceChart from '@/components/controls/passive/OTEPriceChart.vue';
import StructDisplayList from '@/components/controls/passive/StructDisplayList.vue';
import SecondsDisplayField from '@/components/controls/passive/SecondsDisplayField.vue';
import RealNumberDisplayField from '@/components/controls/passive/RealNumberDisplayField.vue';
import DateDisplayField from '@/components/controls/passive/DateDisplayField.vue';
import TimerDisplayField from '@/components/controls/passive/TimerDisplayField.vue';
import TimeDisplayField from '@/components/controls/passive/TimeDisplayField.vue';
import StructControlList from '@/components/controls/StructControlList.vue';
import EnumDisplayField from '@/components/controls/passive/EnumDisplayField.vue';
import DateInput from '@/components/controls/DateInput.vue';
import TextInput from '@/components/controls/TextInput.vue';
import IcoolIcon from '@/components/utils/IcoolIcon.vue';
import isMobileUserAgent from '@/utils/common';
import SettingItem from '@/components/services/SettingItem.vue';
import config from '@/config';
import loadServiceIcons from '@/utils/iconsLoading';
import SchedulerButton from '@/components/services/service/scheduler/SchedulerButton.vue';
// @ts-ignore
import FastClick from 'fastclick';

window.addEventListener('load', () => {
  FastClick.attach(document.body);
}, false);

const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};

// @ts-ignore
Vue.use(VueLogger, options);


// assign lodash to Vue prototype.
// All components inherit from this
// so they will now all be able to access lodash from the this keyword
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// sync router´s current route to vuex store
sync(store, router); // Returns an unsync callback fn

Vue.config.productionTip = false;

Vue.use(longpress);
Vue.use(VueWorker);
Vue.use(BootstrapVue);
Vue.use(ToggleButton);
Vue.use(VueSlideoutPanel);
Vue.use(VueCookies);
Vue.use(VueI18n);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('multiselect', Multiselect);
Vue.component('ButtonSwitch', ButtonSwitch);
Vue.component('RGBPicker', RGBPicker);
Vue.component('Slider', Slider);
Vue.component('SliderSwitch', SliderSwitch);
Vue.component('NumberInput', NumberInput);
Vue.component('SelectBox', SelectBox);
Vue.component('SecondsDisplayField', SecondsDisplayField);
Vue.component('TimerDisplayField', TimerDisplayField);
Vue.component('TimeDisplayField', TimeDisplayField);
Vue.component('RealNumberDisplayField', RealNumberDisplayField);
Vue.component('DateDisplayField', DateDisplayField);
Vue.component('StructControlList', StructControlList);
Vue.component('IcoolIcon', IcoolIcon);
Vue.component('EnumDisplayField', EnumDisplayField);
Vue.component('Timer', Timer);
Vue.component('TimeInput', TimeInput);
Vue.component('TextInput', TextInput);
Vue.component('DateInput', DateInput);
Vue.component('SchedulerButton', SchedulerButton);
Vue.component('SecMillisNumberInput', SecMillisNumberInput);
Vue.component('OTEPriceChart', OTEPriceChart);
Vue.component('StructDisplayList', StructDisplayList);

loadServiceIcons();

// need to be registered globally because nested components
Vue.component('SettingItem', SettingItem);

Vue.prototype.$isMobile = isMobileUserAgent();
Vue.prototype.$backendUrl = (path: string) => new URL(
  path,
  config.ICOOL.BACKEND_HOST,
).href;


/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
